import { Component } from '@angular/core';

@Component({
  selector: 'app-third-party-03',
  template: `
    <div class="center">

    <img height="100%" width="100%" src="assets/images/third-party-03.png" alt="Third Party 03">
  
    </div>`,
  styleUrls: ['./center.style.css'],
  styles: [':host { display: inline-block; }']
})
export class ThirdPartyThirdComponent { } 